import { IS_EVIDENCE_LIBRARY_ENABLED } from '@/app-shell/flags/evidence-flags';
import { useMobilePanel } from '@/app-shell/layout/Navigation/mobile/use-mobile-panel';
import { navV3Messages } from '@/app-shell/layout/Navigation/nav-v3/nav-v3.messages';
import { NavItem } from '@/app-shell/layout/Navigation/sidebar/nav-item';
import { Library } from 'lucide-react';
import { useIntl } from 'react-intl';

/**
 * Nav-v3 "Library" entry — the Evidence library at /library. Rebuilt here
 * because the existing link lives inside the quarantined ChatSidebar.
 */
export const LibraryNavItem = () => {
  const intl = useIntl();
  const { dismissMobileSidebar } = useMobilePanel();

  if (!IS_EVIDENCE_LIBRARY_ENABLED()) {
    return null;
  }

  return (
    <NavItem
      label={intl.formatMessage(navV3Messages.library)}
      icon={<Library />}
      href="/library"
      onClick={dismissMobileSidebar}
      testId="sidebar-link-library"
    />
  );
};
